import baseURL from "../common/axios";
class Contactservice {
  //To Insert Contacts-->MOPCRM API
  create(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("Contacts/Create", dataModel);
  }
  //To Update Contacts-->MOPCRM API
  update(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("Contacts/Update", dataModel);
  }
  //To updateAgent Contacts-->MOPCRM API
  updateAgent(Id, agentId) {
    return baseURL.httpMSMOPCRMUrl.put(
      "Contacts/AssignUpdate?Id=" + Id + "&AssignTo=" + agentId
    );
  }
  //To Delete Contacts-->MOPCRM API
  delete(Id) {
    return baseURL.httpMSMOPCRMUrl.delete("Contacts/Delete?id=" + Id);
  }
  //Active
  active(Id, Status) {
    return baseURL.httpMSMOPCRMUrl.put(
      "Contacts/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  //To Get Contacts List-->MOPCRM API
  getList() {
    return baseURL.httpMSMOPCRMUrl.get("Contacts/List");
  }
  getListCustom(
    startDate,
    endDate,
    PageSize,
    PageNum,
    condition,
    Flag,
    SearchOption
  ) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Contacts/ListCustom?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&Condition=" +
      condition +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      ""
    );
  }

  getListCallCustom(
    startDate,
    endDate,
    PageSize,
    PageNum,
    condition,
    Flag,
    SearchOption
  ) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.get(
      "Contacts/ListCallCustom?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&Condition=" +
      condition +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      ""
    );
  }
  //To Get Contacts & Lead List-->MOPCRM API
  ListAllContacts(
    startDate,
    endDate,
    PageSize,
    PageNum,
    condition,
    Flag,
    SearchOption
  ) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Contacts/ListAllContacts?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&Condition=" +
      condition +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      ""
    );
  }
  //To Get Contacts List-->MOPCRM API
  getById(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Contacts/Get?id=" + Id + "");
  }
  //To Get Contacts List-->MOPCRM API
  updateLeadStatus(Id, LStatusId) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.put(
      "Contacts/LeadStatusUpdate?Id=" + Id + "&LStatusId=" + LStatusId
    );
  }

  getContactDashboardListCustom(branch, agentid, admin, clientId) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Contacts/GetContactDashboardCustom?branch=" +
      branch +
      "&agentid=" +
      agentid +
      "&admin=" +
      admin +
      "&clientId=" +
      clientId
    );
  }
  DashboardList() {
    return baseURL.httpMSMOPCRMUrl.get("Contacts/ContactDashboardList");
  }
  SalutationList() {
    return baseURL.httpMSMOPCRMUrl.get("Common/SalutationList");
  }
}
export default new Contactservice();
